<!-- 创建时间2024/04/24 09:45:02 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：图片类型的播放 -->
<template>
  <div class="yxtbiz-doc-player--picture" v-loading="loading">
    <div class="yxtbiz-doc-player__container" :style="width()">
      <div class="yxtbiz-doc-player__scroll" :class="renderList.length === 1 ? 'is-single' : ''" @scroll="onScroll">
        <div class="yxtbiz-doc-player__wrapper" :style="wrapStyle">
          <div v-for="item in renderList" fit="contain" class="yxtbiz-doc-player__content-item" :key="item._index"
            :style="itemStyle(item)">
            <img v-if="item.url" :src="blobCache[item.url] || item.url" width="100%" fit="contain" />
            <div v-else class="yxtbiz-doc-player__item-placeholder"></div>
          </div>
        </div>
      </div>
      <slot name="watermark"></slot>
    </div>
  </div>
</template>

<script>
import 'whatwg-fetch';
import { addResizeListener, removeResizeListener } from 'yxt-pc';
import { getFileList } from '../../../doc-viewer/src/service';
import propsMixin from '../mixins/props';
import { binarySearch } from '../utils';
const PAGE_SIZE = 10;
export default {
  name: 'picture-viewer',
  mixins: [propsMixin],
  inject: ['getZoom'],
  data() {
    return {
      list: [],
      total: 0,
      imageWidth: 0,
      imageHeight: 0,
      imageRealHeight: 0,
      blobCache: {},
      startIndex: 0,
      buffer: 2,
      scrollTop: 0,
      loading: false
    };
  },
  computed: {
    openVirtual() {
      return this.virtual === true || (this.virtual === 'auto' && this.total > 300);
    },
    from() {
      return Math.max(this.startIndex - this.buffer, 0);
    },
    to() {
      const length = this.list.length;
      if (length === 0) return 0;
      let index = this.startIndex;
      const containerHeight = this.$el.clientHeight;
      for (let i = this.startIndex; i < length; i++) {
        index = i;
        if ((this.list[i]._index + 1) * this.imageRealHeight - this.scrollTop >= containerHeight) break;
      }
      return Math.min(index + this.buffer, length - 1);
    },
    renderList() {
      if (this.openVirtual) return this.list.slice(this.from, this.to + 1);
      return this.list;
    },
    wrapStyle() {
      if (this.openVirtual) return `height: ${this.total * this.imageRealHeight}px; padding-top: ${this.from * this.imageRealHeight}px`;
      return '';
    }
  },
  created() {
    const page = Math.floor(this.start / PAGE_SIZE);
    this.getList(page);
  },
  mounted() {
    addResizeListener(this.$el.querySelector('.yxtbiz-doc-player__scroll'), this.refreshViewer);
  },
  beforeDestroy() {
    removeResizeListener(this.$el.querySelector('.yxtbiz-doc-player__scroll'), this.refreshViewer);
  },
  methods: {
    // 跳转到页码
    scrollToPage(page) {
      const { clientHeight, scrollHeight } = this.$el.querySelector('.yxtbiz-doc-player__scroll');
      let eachPageScrollTop;
      if (this.imageRealHeight > clientHeight) {
        eachPageScrollTop = this.imageRealHeight;
      } else {
        eachPageScrollTop = (scrollHeight - clientHeight) / (this.total - 1);
      }
      this.$el.querySelector('.yxtbiz-doc-player__scroll').scrollTop = eachPageScrollTop * (page - 1) + 1;
    },
    // 视图尺寸变化时刷新
    refreshViewer() {
      this.$nextTick(() => {
        if (!this.imageWidth) return;
        const { clientWidth } = this.$el.querySelector('.yxtbiz-doc-player__container');
        const imageHeight = clientWidth / this.imageWidth * this.imageHeight;
        this.imageRealHeight = imageHeight + 10;
        setTimeout(() => this.handleScroll({ target: { scrollTop: this.scrollTop || 0 } }));
      });
    },

    // 滚动时的处理
    onScroll(e) {
      window.requestAnimationFrame(() => this.handleScroll(e));
    },
    handleScroll(e) {
      this.scrollTop = e.target.scrollTop;
      const startIndex = this._getStartIndex(this.scrollTop);
      this.startIndex = startIndex !== this.startIndex ? startIndex : this.startIndex;
      this.loadDataWithScrollTop(this.scrollTop);
      this.calcPageWithScrollTop(this.scrollTop);
    },
    _getStartIndex(scrollTop) {
      let idx = binarySearch(this.list, scrollTop, this.imageRealHeight) || 0;
      const bottom = (idx + 1) * this.imageRealHeight;
      if (bottom < scrollTop) {
        idx += 1;
      }
      return idx;
    },
    loadDataWithScrollTop(top) {
      const { startIndex, endIndex } = this._getIndexRange(top);
      const pages = this._getPagesWithIndexRange(startIndex, endIndex);
      pages.forEach(page => {
        for (let i = PAGE_SIZE * page; i < Math.min((page + 1) * PAGE_SIZE, this.total); i++) {
          this.list[i].state = 'loading';
        }
        this.getList(page);
      });
    },
    _getIndexRange(top) {
      const { clientHeight } = this.$el.querySelector('.yxtbiz-doc-player__scroll');
      const imageHeight = this.imageRealHeight;
      // 前offset 2， 后offset 2
      const startIndex = Math.max(Math.floor(top / imageHeight) - 2, 0);
      const endIndex = Math.min(Math.floor((top + clientHeight) / imageHeight) + 1, this.total - 1);
      return { startIndex, endIndex };
    },
    _getPagesWithIndexRange(from, to) {
      const pages = [];
      for (let i = from; i <= to; i++) {
        const page = Math.floor(i / PAGE_SIZE);
        if (this.list[i].state === 'unload' && !pages.includes(page)) {
          pages.push(page);
        }
      }
      return pages;
    },
    // 根据滚动高度计算页码
    calcPageWithScrollTop() {
      // 如果图片高度大于窗口高度，已顶部scrollTop为准，反之取平均值
      const { scrollHeight, clientHeight } = this.$el.querySelector('.yxtbiz-doc-player__scroll');
      let page;
      if (this.imageRealHeight > clientHeight) {
        page = Math.floor((this.scrollTop + 1) / this.imageRealHeight) + 1;
      } else {
        page = Math.min(Math.floor(this.scrollTop / ((scrollHeight - clientHeight) / (this.total - 1))) + 1, this.total);
        if (this.scrollTop >= scrollHeight - clientHeight - 10) {
          page = this.total;
        }
      }
      this.$root.$emit('PAGE_CHANGE', page);
    },

    // 样式数据
    itemStyle() {
      return { height: this.imageRealHeight + 'px' };
    },
    width() {
      if (!this.$el) return {};
      let width = this.$el.clientWidth * 0.85;
      if (this.imageWidth > 0 && this.imageWidth < width) {
        width = this.imageWidth;
      }
      const zoom = this.getZoom();
      width = (1 + (zoom > 0 ? '0.3' : '0.1') * zoom) * (width / this.$el.clientWidth);
      return { width: width * 100 + '%' };
    },

    // 数据处理：获取地址列表、获取页码数、初始化位置信息
    async getList(page) {
      if (this.list.length === 0) this.loading = true;
      const orgId = this.watermarkOrgId || (this.showWatermark && !this.watermarkConfig.enabled || this.serverGroupId ? '' : 'nowarterMark'); // 自定义水印若是不开启，返回图片强制不带水印
      const { playDetails } = await getFileList({
        fileId: this.fileId,
        serviceGroup: this.serverGroupId,
        clientType: 0,
        limit: PAGE_SIZE,
        offset: page * PAGE_SIZE,
        appCode: this.watermarkCode,
        deptName: localStorage.deptName || '',
        username: localStorage.username || '',
        fullname: localStorage.fullname || '',
        orgId
      });
      // this.realWatermarkConfig = {...watermarkConfig, ...this.watermarkConfig}
      if (playDetails && playDetails.length) {
        if (this.total === 0) {
          const { desc, url } = playDetails[0];
          try {
            const page = JSON.parse(desc);
            await this._setImageSize(url, ~~page.width, ~~page.height);
            this.total = page.count || 1;
            this._setListData(this.total);
            this.$root.$emit('PAGES_INIT', this.total);
          } catch (e) { console.error(e); }
        }
      }
      const list = playDetails.map((item, index) => ({ state: 'loaded', url: item.url, _index: page * PAGE_SIZE + index }));
      if (this.openVirtual) this._setUrlBlobCache(list);
      this.list.splice(page * PAGE_SIZE, playDetails.length, ...list);
      this.loading = false;
    },
    async _setImageSize(url, width, height) {
      const clientWidth = this.$el.clientWidth * 0.85; // 这里容器宽度计算和width()里计算一致
      return new Promise((resolve, reject) => {
        if (width && height) {
          this.imageWidth = width;
          this.imageHeight = height;
          const imageHeight = Math.min(clientWidth, this.imageWidth) / this.imageWidth * this.imageHeight;
          this.imageRealHeight = imageHeight + 10;
          resolve();
          return;
        }
        const image = new Image();
        image.src = url;
        image.onload = () => {
          this.imageWidth = image.width;
          this.imageHeight = image.height;
          const imageHeight = Math.min(clientWidth, this.imageWidth) / this.imageWidth * this.imageHeight;
          this.imageRealHeight = imageHeight + 10;
          resolve();
        };
        image.onerror = () => reject;
      });
    },
    _setListData(total) {
      const list = [];
      for (let i = 0; i < total; i++) {
        list.push({
          state: 'unload',
          _index: i
        });
      }
      this.list = list;
      this.$nextTick(() => {
        this.scrollToPage(this.start || 1);
      });
    },
    _setUrlBlobCache(list) {
      list.forEach(item => {
        this.setBlobUrl(item.url);
      });
    },
    setBlobUrl(url) {
      fetch(url).then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.blob();
      })
        .then(blob => {
          const blobUrl = URL.createObjectURL(blob);
          if (!this.blobCache[url]) this.blobCache[url] = blobUrl;
        });
    }
  }
};
</script>